import { useToast as useNuxtToast } from "@nuxt/ui/composables";
import type { Intent } from "./types";

export const TOAST_ICONS: Record<Intent, string> = {
  success: "i-material-symbols-check-circle-rounded",
  error: "i-material-symbols-error-rounded",
  warning: "i-material-symbols-warning-rounded",
  info: "i-material-symbols-info-rounded",
};

export type ToastAction = { label: string; onClick: () => void };

/** The one place a Hubb toast's look is decided. */
export function toToast(intent: Intent, message: string, options: { action?: ToastAction; duration?: number } = {}) {
  const { action, duration } = options;
  return {
    title: message,
    color: intent,
    icon: TOAST_ICONS[intent],
    actions: action
      ? [{ label: action.label, color: "neutral" as const, variant: "outline" as const, onClick: action.onClick }]
      : undefined,
    duration,
  };
}

type Notify = (message: string, action?: ToastAction) => void;

export type UseToast = {
  error: Notify;
  warning: Notify;
  success: Notify;
  info: Notify;
};

/** Default duration comes from the `:toaster` prop on UApp in App.vue. */
export default function useToast(): UseToast {
  const toast = useNuxtToast();

  function add(intent: Intent, message: string, action?: ToastAction) {
    toast.add(toToast(intent, message, { action }));
  }

  return {
    error: (message, action) => add("error", message, action),
    warning: (message, action) => add("warning", message, action),
    success: (message, action) => add("success", message, action),
    info: (message, action) => add("info", message, action),
  };
}
